




      
import Vue from 'vue'  
import Component from 'vue-class-component'  
 import {loadLanguageAsync,locales} from '@/locale/vueI18n'  

@Component({
  name: 'Printer',    
})
export default class Printer extends Vue {  
      
    mounted(){
              
    }

    get printMode()
    {
      return this.$store.myGetters.printMode
    }

    print() {        
      this.$store.myActions.UI_SET_PRINT_MODE(!this.printMode);
    }      
}
